import { render, staticRenderFns } from "./IconSvgWebp.vue?vue&type=template&id=f576e6c0&scoped=true&"
import script from "./IconSvgWebp.vue?vue&type=script&lang=js&"
export * from "./IconSvgWebp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f576e6c0",
  null
  
)

export default component.exports